import React from "react";
/** @jsxImportSource @emotion/react */
import {css} from "@emotion/react";
import {useTheme} from "@emotion/react";
import {getImageUrl} from "../../../context/ApplicationContextProvider";
import {useMobileDetect} from "../../../utils/Hooks";
import {SECRET_NOTE} from "../../_presentational/buttons";

const HoverBlueSecretNote = () => {
    const {is_mobile} = useMobileDetect();

    // css style
    const {css} = useComponentStyle();

    return <SECRET_NOTE css={is_mobile ? css.hover_blue_secret_note_responsive_css : css.hover_blue_secret_note_css} />;
};

export default HoverBlueSecretNote;

export const useComponentStyle = () => {
    const theme = useTheme();
    return {
        css: {
            hover_blue_secret_note_css: css({
                backgroundColor: theme.colors.w,
                color: theme.colors.black,
                "& .download-icon": {
                    background: `url(${getImageUrl(
                        "image/course/ic_download_black.png"
                    )}) center center/contain no-repeat`,
                },
                "&:hover": {
                    backgroundColor: theme.colors.bearu_primary,
                    color: theme.colors.w,
                    border: "none",
                    ".download-icon": {
                        background: `url(${getImageUrl(
                            "image/course/ic_download_white.png"
                        )}) center center/contain no-repeat`,
                    },
                },
            }),
            hover_blue_secret_note_responsive_css: css({
                transition: "all .2s",
                "@media (max-width: 320px)": {
                    fontSize: theme.font_size.f14,
                },
            }),
        },
    };
};
